import PigGroupDiagnosesManager from './PigGroupDiagnosesManager';

export default PigGroupDiagnosesManager;
